(function($){
  $(document).ready(function() {

  	//zones de texte
  	$(".ouvre_paragraphe").on("click", function(e) {
  		e.preventDefault();
  	    var id=$(this).data("idelt");
        // console.log('ici'+id);
  	    $("#intro"+id).slideToggle();
  	    $("#parag"+id).slideToggle();
  	    classlien = $("#lienparag" + id).attr("class");
  	    if (classlien == "lienplusparag"){
  	        $("#lienparag" + id).attr("class", "lienmoinsparag");
        }
  	    else{
  	        $("#lienparag" + id).attr("class", "lienplusparag");
        }
  	    $(".fiche_ecole .tabnom .tdh4").each(function (){
  	        $(this).removeAttr("width");
  	        width = $('h4', this).width() + 10;
  	        $(this).attr("width", width);
  	    });
  	});

    $('.slider').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        dots: true
    });

  	$('.diaporama').each(function(){
        $(this).slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            // adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 3000,
        });
        $(this).magnificPopup({
            delegate: 'li a',
            type: 'image',
            mainClass: 'mfp-zoom-in mfp-img-mobile',
            image: {
                verticalFit: true,
                titleSrc: function(item) {
                    var img = item.el.find('img');
                    return img.attr('alt');
                }
            },
            gallery: {
              enabled: true,
              preload: [1,2],
            },
            tLoading: '',
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
                imageLoadComplete: function() {
                    var self = this;
                    self.wrap.addClass('mfp-image-loaded');
                },
                close: function() {
                  this.wrap.removeClass('mfp-image-loaded');
                },
            },
        });
    });

    $('.lightbox').magnificPopup({
        type: 'image'
    });

    $('.autogrow').autoGrow();

    $(document).on('popinCreated', function(){
        $('.autogrow').autoGrow();
    });

    $('.photo-link').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-with-zoom mfp-img-mobile',
        image: {
            verticalFit: true,
            titleSrc: function(item) {
                var img = item.el.find('img');
                return img.attr('alt');
            }
        },
        gallery: {
          enabled: true,
          preload: [1,2],
        },
        zoom: {
            enabled: true
        }
    });

    $('.galerie').each(function(){
        $(this).magnificPopup({
            delegate: 'li a',
            type: 'image',
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
                verticalFit: true,
                titleSrc: function(item) {
                    var img = item.el.find('img');
                    return img.attr('alt');
                }
            },
            gallery: {
              enabled: true,
              preload: [1,2],
            },
            tLoading: '',
            zoom: {
                enabled: true
            }
        });
    });

    $(".paragraphe img").each(function () {
       let align = $(this).css("float");
        if (align == "right"){
             $(this).css("margin-right", "0");
             $(this).css("padding-left", "15px");
        }
        if (align == "left"){
             $(this).css("margin-left", "0");
             $(this).css("padding-right", "15px");
        }
    });

    $(".page-content table").each(function () {
        if($(this).attr("border") != undefined) {
          border = $(this).attr("border");
          if ( border > 0 ) {
              $(this).attr("border", 0);
              $(this).addClass("tableborder");
          }
        }
    });

    $('[role="tab"]').on('click', function(e){
        var tab_liste = $(this).parents('[role="tablist"]'),
            mes_tabs = tab_liste.find('[role="tab"]'),
            target = $(this).attr('aria-controls'),
            mon_panel = $("#" + target),
            mes_panneaux = mon_panel.siblings('[role="tabpanel"]');
        mes_tabs.attr("aria-selected", "false");
        $(this).attr("aria-selected", "true");

        mes_panneaux.removeClass('active').addClass('hide');
        mon_panel.removeClass('hide').addClass('active');
    });

    //RDV
  	$(".inscription").on("click", function(e) {
  		e.preventDefault();
  	    var id=$(this).data("id");
  	    $(".form_inscription").html("");
  	    $(".form_inscription").hide();
  	    $.ajax({
  	        url: '/inc/xhr/actions.php?action=formulaire_inscription&id='+id,
  	        success: function(data){
  	            $("#form_inscription" + id).html(data);
  	            $("#form_inscription" + id).show();
  	        }
  	    });
  	});
    // console.log(window.location.hash);
    if (window.location.hash == "#inscription") {
        $(".inscription").trigger('click');
    }

    $(".ajouter_commentaire").on("click", function(e) {
        e.preventDefault();
        $("#formcommentaire").show();
    });



    //RDV
    $(".plusdinfos-trombi").on("click", function(e) {
      e.preventDefault();
        var id=$(this).data("id");
        $.ajax({
            url: '/inc/xhr/actions.php?action=get_trombi_infos&id='+id,
            success: function(data){
                //ouvre_popin(data);
                $.popin.alert({title: "", message: data, button: "fermer"});
            }
        });
    });

  })
})(jQuery);


function fermer_inscription(id) {
    $("#form_inscription" + id).hide();
    $("#form_inscription" + id).html("");
}
